export const RETURN_TO_APPLICATION_AUTO = 'return_to_application_auto'
export const INSTANT_DASHING_V2 = 'instant_dashing_v2'
export const INSTANT_DASHING = 'instant_dashing'
export const IS_AT_CAPACITY_V2 = 'is_at_capacity_v2'
export const DX_CRO_LP_GRADUATION_Q1_2020 = 'dx_cro_lp_graduation_q1_2020'
export const DX_CRO_LP_GRADUATION_Q3_2020 = 'dx_cro_lp_graduation_q3_2020'
export const DX_ID_FAST_PAY_Q1_2020 = 'dx_id_fast_pay_q1_2020'
export const NEEDS_VEHICLE_INFO = 'needs_vehicle_info'
export const DX_EXTREME_LATENESS = 'dx_extreme_lateness'
export const W_MODEL_EXPERIMENT = 'w_model_experiment'
export const NEEDS_OFFER_LETTER = 'needs_offer_letter'
export const DX_PHONE_NUMBER_VERIFICATION = 'phone_number_verification'
export const TOKENIZATION = 'tokenization'
export const DX_WEB_JAPAN_SUPPORT = 'dx_web_jpn_support'
export const DX_PHONE_NUMBER_VERIFICATION_SIGNUP =
  'dasher_phone_number_verification_signup'
export const NO_W9_EXPERIMENT = 'no_w9_experiment'
export const ADDRESS_COLLECTION_AFTER_DASH = 'address_collection_after_dash'
export const ADDRESS_COLLECTION_AFTER_X_DASHES =
  'address_collection_after_x_dashes'
export const IDENTITY_VERIFICATION = 'identity_verification'
export const IDENTITY_VERIFICATION_ANDROID = 'identity_verification_android'
export const HAS_COMPLETED_FIRST_DELIVERY = 'has_completed_first_delivery'
export const BGC_STATUS_UPDATE = 'bgc_status_update'
export const DX_SAFETY_COURSE = 'dx_safety_course'
export const DASHER_WEB_IDENTITY_SERVICE_MIGRATION =
  'dasher_web_identity_service_migration'
export const DX_BANK_ACCOUNT_SKIP = 'dx_bank_account_skip'
export const DASHER_PRIVACY_PORTAL = 'dx_show_privacy_portal'
export const DX_BANK_ACCOUNT_SKIP_ONBOARDING_PROGRESS =
  'dx_bank_account_skip_onboarding_progress'
export const DX_ACTIVATED_NO_FIRST_DASH = 'dx_activated_no_first_dash'
export const DX_ACTIVATED_NO_FIRST_DASH_IOS = 'dx_activated_no_first_dash_ios'
export const DX_ACTIVATED_NO_FIRST_DASH_LOCATION =
  'dx_activated_no_first_dash_location'
export const AN_DX_ANFD_ONBOARDING = 'an_dx_anfd_onboarding'
export const REFERRAL_CODE_REMOVAL = 'referral_code_removal'

// this is just a combo of experiments
export const ADDRESS_COLLECTION_INSTANT_DASH = 'address_collection_instant_dash'
export const IDV_REFERRAL = 'idv_referral'
export const IDV_SESSION_LIMIT = 'idv_session_limit'

export const AUS_NCC_BGC = 'aus_ncc_bgc'
export const GERMANY_DX_ONBOARDING_V2 = 'germany_dx_onboarding_v2'
export const JAPAN_DX_ONBOARDING_V2 = 'japan_dx_onboarding_v2'

export const DX_EXCITEMENT_PROMOTIONS_PAGE = 'dx_excitement_promotions_page'
export const DX_EXCITEMENT_PROFILE_PAGE = 'dx_excitement_profile_page'

export const USE_USER_ME_ENDPOINT = 'use_user_me_endpoint'
export const DX_DRIVERS_LICENSE_TOKENIZATION = 'dx_drivers_license_tokenization'

export default {
  RETURN_TO_APPLICATION_AUTO,
  INSTANT_DASHING,
  INSTANT_DASHING_V2,
  IS_AT_CAPACITY_V2,
  DX_CRO_LP_GRADUATION_Q1_2020,
  DX_CRO_LP_GRADUATION_Q3_2020,
  DX_ID_FAST_PAY_Q1_2020,
  NEEDS_VEHICLE_INFO,
  DX_EXTREME_LATENESS,
  W_MODEL_EXPERIMENT,
  NEEDS_OFFER_LETTER,
  DX_PHONE_NUMBER_VERIFICATION,
  TOKENIZATION,
  DX_WEB_JAPAN_SUPPORT,
  DX_PHONE_NUMBER_VERIFICATION_SIGNUP,
  NO_W9_EXPERIMENT,
  ADDRESS_COLLECTION_AFTER_DASH,
  IDENTITY_VERIFICATION,
  IDENTITY_VERIFICATION_ANDROID,
  HAS_COMPLETED_FIRST_DELIVERY,
  ADDRESS_COLLECTION_INSTANT_DASH,
  BGC_STATUS_UPDATE,
  DX_SAFETY_COURSE,
  DASHER_WEB_IDENTITY_SERVICE_MIGRATION,
  DX_BANK_ACCOUNT_SKIP,
  IDV_REFERRAL,
  DASHER_PRIVACY_PORTAL,
  DX_ACTIVATED_NO_FIRST_DASH,
  DX_ACTIVATED_NO_FIRST_DASH_IOS,
  IDV_SESSION_LIMIT,
  AN_DX_ANFD_ONBOARDING,
  REFERRAL_CODE_REMOVAL,
  AUS_NCC_BGC,
  GERMANY_DX_ONBOARDING_V2,
  JAPAN_DX_ONBOARDING_V2,
  DX_ACTIVATED_NO_FIRST_DASH_LOCATION,
  DX_EXCITEMENT_PROMOTIONS_PAGE,
  DX_EXCITEMENT_PROFILE_PAGE,
  USE_USER_ME_ENDPOINT,
  DX_DRIVERS_LICENSE_TOKENIZATION,
}
